__turbopack_context__.v({
  "aboutPage": "HowWeBuildProductsSection-module-scss-module__Lb6bsq__aboutPage",
  "button": "HowWeBuildProductsSection-module-scss-module__Lb6bsq__button",
  "card": "HowWeBuildProductsSection-module-scss-module__Lb6bsq__card",
  "container": "HowWeBuildProductsSection-module-scss-module__Lb6bsq__container",
  "description": "HowWeBuildProductsSection-module-scss-module__Lb6bsq__description",
  "fade-in-up": "HowWeBuildProductsSection-module-scss-module__Lb6bsq__fade-in-up",
  "title": "HowWeBuildProductsSection-module-scss-module__Lb6bsq__title",
  "visible": "HowWeBuildProductsSection-module-scss-module__Lb6bsq__visible",
});
